<h2 mat-dialog-title>{{ title | translate }}</h2>
<div mat-dialog-content>
  <!-- Componente a cargar -->
  <ng-container #viewContainerRef></ng-container>
</div>
<div mat-dialog-actions>
  <button mat-raised-button color="accent" (click)="closeDialog()">
    {{ noLabel | translate }}
  </button>
  <button *ngIf="!hideYesButton" class="create" mat-raised-button color="primary"
    [disabled]="componentInstance ? componentInstance[formName]?.invalid : true" (click)="onSubmit()">
    {{ yesLabel | translate }}
  </button>
</div>